import React, { useEffect, useState } from "react";
import {Input, Modal, Table, message, Form, Button, InputNumber} from 'antd';
import type { ColumnsType } from 'antd/es/table';
import {
  getAllMenuApi,
  updateCategoryApi,
  createCategoryApi,
  deleteCategoryApi
} from "../../../api/ManageApi";
import GlobalLoader from "../../../components/GlobalLoading";

const Category = () => {
  const [dataList, setDataList] = useState<any>();
  const [modalItem, setModalItem] = useState<any>();
  const [filter, setFilter] = useState({
    refresh: true,
  });
  const [form] = Form.useForm();

  useEffect(() => {
    getAllMenuApi().then((res) => {
      if (res.status) {
        setDataList(res?.data || [])
      }
    });
  }, [filter]);

  useEffect(() => {
    form.resetFields();
    form.setFieldsValue(modalItem)
  }, [modalItem, form])

  const closeModal = () => setModalItem(undefined);

  const handleAddCategory = (menu: any) => {
    setModalItem({
      menu: menu
    })
  }
  const handleEditCategory = (menu: any, category: any) => setModalItem({
    ...category,
    menu: menu
  })

  const handleDeleteCategory = (category: any) => {
    GlobalLoader.show();
    deleteCategoryApi(category?.id || 0).then((res) => {
      if (res.status) {
        setFilter(data => ({...data }))
      } else {
        message.error(res?.error || '')
      }
      GlobalLoader.hide();
    })
  }

  const handleSubmit = async () => {
    try {
      await form.validateFields();
    } catch (e) {
      return;
    }
    let data = form.getFieldsValue();
    if(!data?.name?.zh && !data?.name?.zh && !data?.name?.zh){
      message.error("请至少填写一个中文或英文或日文名称")
      return null;
    }
    GlobalLoader.show();
    if(!!data?.id) {
      updateCategoryApi({
        id: data?.id,
        sequence: data?.sequence,
        name: data?.name,
        group: data?.group,
      }).then((res) => {
        if (res.status) {
          setFilter(data => ({...data }))
          closeModal();
        } else {
          message.error(res?.error || '')
        }
        GlobalLoader.hide();
      })
    } else {
      createCategoryApi({
        sequence: data?.sequence,
        name: data?.name,
        menu_id: modalItem?.menu?.id,
        group: data?.group,
      }).then((res) => {
        if (res.status) {
          setFilter(data => ({...data }))
          closeModal();
        } else {
          message.error(res?.error || '')
        }
        GlobalLoader.hide();
      })
    }
  }

  const columns: ColumnsType<any> = [
    {
      title: "中文名称",
      key: 'name',
      width: 200,
      render: (r) => r?.name?.zh || ""
    },
    {
      title: "英文名称",
      key: 'name',
      width: 200,
      render: (r) => r?.name?.en || ""
    },
    {
      title: "日文名称",
      key: 'name',
      width: 200,
      render: (r) => r?.name?.ja || ""
    },
    {
      title: "操作",
      key: 'actions',
      width: 100,
      fixed: 'right',
      render: (r) => <>
        {
          !!r?.is_show &&
          !['about', 'contact', 'news'].includes(r?.page_config?.type) &&
          <Button type='link' size='small' onClick={() => handleAddCategory(r)}>
            添加分类
          </Button>
        }
      </>
    }
  ]

  return <>
    <div>
      <Modal
        centered
        width={700}
        title={`${!!modalItem?.id ? '编辑' : '创建'}分类`}
        open={!!modalItem}
        onCancel={(closeModal)}
        onOk={handleSubmit}
      >
        <Form
          form={form}
          style={{margin: '3em 0'}}
          labelCol={{ span: 6 }}>
          <Form.Item label='所属菜单'>
            <Input disabled value={
              modalItem?.menu?.name?.zh ||
              modalItem?.menu?.name?.en ||
              modalItem?.menu?.name?.ja
            } />
          </Form.Item>
          <Form.Item name="id" hidden>
            <Input />
          </Form.Item>
          <Form.Item name="menu_id" hidden>
            <Input />
          </Form.Item>
          <Form.Item name={['name', 'zh']} label={'中文名称'}>
            <Input />
          </Form.Item>
          <Form.Item name={['name', 'en']} label={'英文名称'}>
            <Input />
          </Form.Item>
          <Form.Item name={['name', 'ja']} label={'日文名称'}>
            <Input />
          </Form.Item>
          <Form.Item name={'group'} label={'分组'}>
            <Input />
          </Form.Item>
          <Form.Item
            label={'排序权重'}
            name="sequence">
            <InputNumber min={0} step={1} style={{width: "100%"}} />
          </Form.Item>
        </Form>
      </Modal>
      <Table
        size='small'
        scroll={{ x: 700, scrollToFirstRowOnChange: true }}
        pagination={false}
        rowKey={r => r.id}
        columns={columns}
        dataSource={dataList || []}
        expandable={{
          rowExpandable: (r: any) => !!r.is_show && !['about', 'contact', 'news'].includes(r?.page_config?.type),
          expandedRowKeys: (dataList || []).filter((r: any) =>
            !!r.is_show &&
            !['about', 'contact', 'news'].includes(r?.page_config?.type) &&
            (r.categories || []).length > 0
          ).map((r: any) => r.id),
          expandedRowRender: r => <Table
            size='small'
            scroll={{ x: 850, scrollToFirstRowOnChange: true }}
            pagination={false}
            rowKey={c => c.id}
            columns={[
              {
                title: "排序权重",
                key: 'sequence',
                width: 100,
                render: (r) => r?.sequence
              },
              {
                title: "中文名称",
                key: 'name',
                width: 200,
                render: (r) => r?.name?.zh || ""
              },
              {
                title: "英文名称",
                key: 'name',
                width: 200,
                render: (r) => r?.name?.en || ""
              },
              {
                title: "日文名称",
                key: 'name',
                width: 200,
                render: (r) => r?.name?.ja || ""
              },
              {
                title: "分组",
                key: 'group',
                width: 200,
                render: (r) => r?.group || ""
              },
              {
                title: "操作",
                key: 'actions',
                width: 150,
                fixed: 'right',
                render: (c) => <>
                  <Button type='link' size='small' onClick={() => handleEditCategory(r, c)}>编辑</Button>
                  <Button type='link' size='small' danger onClick={() => handleDeleteCategory(c)}>删除</Button>
                </>
              }
            ]}
            dataSource={r.categories || []}
          />,
        }}
      />
    </div>
  </>;
};

export default Category;